import { Property } from '../../../Shared/Services/Properties/Models/Property';

export function createMarkerClusters(data: Property[]) {
  const clusters: Record<string, Property | Property[]> = {};

  for (const item of data) {
    const key = `${item.geo.lat}-${item.geo.lng}`;

    if (key in clusters) {
      if (Array.isArray(clusters[key])) {
        (clusters[key] as Property[]).push(item);
      } else {
        clusters[key] = [clusters[key] as Property, item];
      }
    } else {
      clusters[key] = item;
    }
  }

  return clusters;
}
